﻿import $ from "jquery";

const hoverUrlAttr = "data-logo-hover-url",
	loadingSelector = "div[data-logo-hover-loading]",
	displayModeAttr = "data-display-mode";

export default class Program {
	constructor(logo, settings) {
		this.$icon = logo.refs.$icon;
		this.$popup = logo.refs.$popup;

		this.popupId = logo.popupId;

		this.settings = settings;
		this.logEvent = logo.logEvent;

		this.hasIframe = logo.hasIframe;
	}

	initIconClick() {
		this.$icon.on("click", () => this.open());
	}

	triggerShowEvent() {
		$(document).trigger("ccs.logo-shown", {
			entryId: this.popupId
		});

		this.hoverOpenTime = new Date().getTime();
		this.isPopupOpened = true;

		const clientParams = {
			Action: "hover"
		};

		this.dispatchEvent(clientParams);
	}

	triggerHideEvent() {
		$(document).trigger("ccs.logo-hidden", {
			entryId: this.popupId
		});

		const hoverTime = Math.ceil((new Date().getTime() - this.hoverOpenTime) / 1000);
		const clientParams = {
			Action: "hover-time",
			Qty: hoverTime
		};

		this.isPopupOpened = false;
		this.dispatchEvent(clientParams);
	}

	dispatchEvent(clientParams) {
		ccs_cc_log.dispatchEvent(this.logEvent, clientParams);
	}

	open() {
		if (this.$icon[0].title === "HP Modular") {
			return;
		}
		const event = $.Event("ccsLogoOpen");

		this.$icon.trigger(event);

		if (event.isDefaultPrevented()) {
			return;
		}

		if (this.hasIframe) {
			if (this.showLoadingIndicator) {
				this.showLoading();
			}

			this.toggleIframeSrc();
		}

		this.openPopup();
		this.triggerShowEvent();
	}

	close() {
		this.$icon.trigger("ccsLogoClose");

		if (this.hasIframe) {
			this.hideLoading();
			this.toggleIframeSrc();
		}

		this.closePopup();
		this.triggerHideEvent();
	}

	toggleIframeSrc() {
		const $iframe = this.$popup.find("iframe");
		const $iframeContainer = $iframe.parent();

		var src = !$iframe.src
			? $iframe.attr(hoverUrlAttr)
			: "about:blank";

		var displayMode = $iframe.attr(displayModeAttr);
		if (displayMode === "Mobile") {
			src += "&mobile=1";
		}

		$iframe.detach();
		$iframe.attr("src", src);
		$iframe.appendTo($iframeContainer);
	}

	showLoading() {
		const $loading = this.$popup.find(loadingSelector);

		this.showIndicatorTimeout = setTimeout(() => {
			this.isIndicatorShown = true;
			$loading.show();
		}, 1000);
	}

	hideLoading() {
		if (!this.isIndicatorShown) {
			clearTimeout(this.showIndicatorTimeout);

			return;
		}

		this.isIndicatorShown = false;

		this.$popup
			.find(loadingSelector)
			.hide();
	}

	openPopup() { }

	closePopup() { }

	resize() { }
}
